import { render, staticRenderFns } from "./PointBank.vue?vue&type=template&id=2b72db1a"
import script from "./PointBank.vue?vue&type=script&lang=js"
export * from "./PointBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports